module.exports = __webpack_public_path__ + "static/media/service-block-3@4x.5c211ab1.jpg";